<template>
  <div>
    <!-- Dropzone -->
    <vue-dropzone 
      ref="myVueDropzone" 
      id="dropzone" 
      :options="dropzoneOptions"
      @vdropzone-success="afterUpload"
    />
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'FileUploader',
  components: {
    vueDropzone
  },
  data() {
    return {
      dropzoneOptions: {
        url: '/api/upload',     // backend API endpoint
        thumbnailWidth: 150,
        maxFilesize: 5,         // in MB
        headers: { "My-Awesome-Header": "header value" },
        acceptedFiles: ".jpg,.jpeg,.png,.pdf,.doc,.docx"
      }
    }
  },
  methods: {
    afterUpload(file, response) {
      console.log('File uploaded:', file)
      console.log('Server response:', response)
    }
  }
}
</script>
